module.exports = __webpack_public_path__ + "static/cover1-bf6bf0faf115f478535a1216feab6d19.png";